import {useContext, useMemo} from 'react';

import {CustomizeJourneyContext} from '@amblique/king-living/app/context/customize-journey-context';
import {resolveCommittedConfiguredImageUrl} from '@amblique/king-living/app/utils/gallery-resource-utils';

/**
 * Hero image URL for the committed customize configuration (cart, upsell).
 *
 * @param {Object|null|undefined} masterProduct
 * @param {{ enabled?: boolean, requireCover?: boolean }} [options]
 * @returns {string|null}
 */
export function useCommittedConfiguredImageUrl(
  masterProduct,
  {enabled = true, requireCover = true} = {}
) {
  const selections = useContext(CustomizeJourneyContext)?.committedSelection?.selections;

  return useMemo(() => {
    if (!enabled) return null;

    return resolveCommittedConfiguredImageUrl(masterProduct, selections, {requireCover});
  }, [enabled, masterProduct, selections, requireCover]);
}
